var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { hasNode, toggleList } from '@progress/kendo-editor-common';
import { onDownPreventDefault } from './utils';
import { registerForLocalization, provideLocalizationService } from '@progress/kendo-react-intl';
import { messages } from './../messages';
/**
 * @hidden
 */

export var ListToolNS;

(function (ListToolNS) {
  /**
   * @hidden
   */
  ListToolNS.createListTool = function (settings) {
    var Tool = function (_super) {
      __extends(ListTool, _super);

      function ListTool() {
        return _super !== null && _super.apply(this, arguments) || this;
      }

      ListTool.prototype.render = function () {
        var _a = this.props,
            view = _a.view,
            render = _a.render,
            buttonProps = __rest(_a, ["view", "render"]);

        var isActive = false;
        var localization = provideLocalizationService(this);
        var titleKey = settings.messages.title;
        var types = settings.types;
        var listType = settings.listType;

        if (view) {
          var state = view.state;
          var nodes = state.schema.nodes;
          var hasOl = hasNode(state, nodes[types.orderedList]),
              hasUl = hasNode(state, nodes[types.bulletList]);

          if (listType === types.orderedList) {
            isActive = hasOl && !hasUl;
          } else {
            isActive = !hasOl && hasUl;
          }
        }

        var button = React.createElement(Button, __assign({
          onClick: function onClick() {
            return view && toggleList(view.state, view.dispatch, view, __assign({
              listType: listType
            }, types), settings.commandName);
          },
          togglable: true,
          selected: isActive,
          title: localization.toLanguageString(titleKey, messages[titleKey])
        }, onDownPreventDefault, settings.props, buttonProps));
        return render ? render.call(undefined, button, {
          view: view
        }) : button;
      };

      return ListTool;
    }(React.Component);

    registerForLocalization(Tool);
    return Tool;
  };
})(ListToolNS || (ListToolNS = {}));